import {
    ExerciseCategory,
    InterfaceLang,
    InterfaceLocale,
    Level,
    Model,
    Motivation,
    StudyLanguage,
    UserLanguage
} from "types";

interface Locale {
    lang: InterfaceLang;
    locale: InterfaceLocale;
    localizedName: string;
}

export const DAILY_EXERCISES_LIMIT = 5;

export const exerciseCategories: ExerciseCategory[] = [
    "listening",
    "speaking",
    "reading",
    "writing"
];

export const interfaceLanguages: Locale[] = [
    {
        lang: "en-us",
        locale: "en",
        localizedName: "🇺🇸 English"
    },
    {
        lang: "es",
        locale: "es",
        localizedName: "🇪🇸 Español"
    },
    {
        lang: "fr",
        locale: "fr",
        localizedName: "🇫🇷 Français"
    },
    {
        lang: "de",
        locale: "de",
        localizedName: "🇩🇪 Deutsch"
    },
    {
        lang: "it",
        locale: "it",
        localizedName: "🇮🇹 Italiano"
    },
    {
        lang: "pt-br",
        locale: "pt-br",
        localizedName: "🇧🇷 Português"
    },
    {
        lang: "zh-cn",
        locale: "zh",
        localizedName: "🇨🇳 中文"
    },
    {
        lang: "ja",
        locale: "ja",
        localizedName: "🇯🇵 日本語"
    },
    {
        lang: "ko",
        locale: "ko",
        localizedName: "🇰🇷 한국어"
    }
];

export const mapLocaleToFlagAndNativeName: Record<InterfaceLocale, string> = {
    en: "🇺🇸 English",
    es: "🇪🇸 Español",
    fr: "🇫🇷 Français",
    de: "🇩🇪 Deutsch",
    it: "🇮🇹 Italiano",
    zh: "🇨🇳 中文",
    ja: "🇯🇵 日本語",
    ko: "🇰🇷 한국어",
    "pt-br": "🇧🇷 Português"
};

export const userLanguages: UserLanguage[] = [
    "en-US",
    "es-ES",
    "it-IT",
    "fr-FR",
    "pt-BR",
    "de-DE",
    "ja-JP",
    "zh-CN",
    "ko-KR"
];

export const mapLanguageToFlag: Record<UserLanguage, string> = {
    "en-US": "🇺🇸",
    "es-ES": "🇪🇸",
    "it-IT": "🇮🇹",
    "pt-BR": "🇧🇷",
    "de-DE": "🇩🇪",
    "fr-FR": "🇫🇷",
    "ja-JP": "🇯🇵",
    "zh-CN": "🇨🇳",
    "ko-KR": "🇰🇷"
};

export const studyLanguages: StudyLanguage[] = [
    "en-US",
    "es-ES",
    "it-IT",
    "pt-BR",
    "de-DE"
];

export const mapLanguageCodeToName = {
    "en-US": "English",
    "es-ES": "Spanish",
    "it-IT": "Italian",
    "fr-FR": "French",
    "pt-BR": "Portuguese",
    "de-DE": "German",
    "ja-JP": "Japanese"
} as Record<UserLanguage, string>;

export const mapLanguageCodeToVoice = {
    "en-US": "en-US-Wavenet-F",
    "es-ES": "es-ES-Neural2-D",
    "it-IT": "it-IT-Neural2-A",
    "pt-BR": "pt-BR-Wavenet-C",
    "de-DE": "de-DE-Neural2-F"
} as Record<StudyLanguage, string>;

export const mapLanguageCodeToCountry = {
    "en-US": "United States",
    "es-ES": "Spain",
    "it-IT": "Italy",
    "pt-BR": "Brazil",
    "de-DE": "Germany"
} as Record<UserLanguage, string>;

export const models: Model[] = ["curiosities", "daily", "airport", "work"];

export const exerciseModels: Model[] = [
    "curiosities",
    "daily",
    "airport",
    "work"
];

export const modelToTranslationEN: Record<Model, string> = {
    curiosities: "Curiosities about the country where this language is spoken",
    daily: "Daily life conversation",
    work: "Dialog between two work colleagues",
    airport: "Looking for a gate at the airport"
};

export const modelToTranslationES: Record<Model, string> = {
    curiosities: "Curiosities about the country where this language is spoken",
    daily: "Daily life conversation",
    work: "Dialog between two work colleagues",
    airport: "Looking for a gate at the airport"
};

export const modelToTranslationIT: Record<Model, string> = {
    curiosities: "Curiosities about the country where this language is spoken",
    daily: "Daily life conversation",
    work: "Dialog between two work colleagues",
    airport: "Looking for a gate at the airport"
};

export const modelToTranslationDE: Record<Model, string> = {
    curiosities: "Curiosities about the country where this language is spoken",
    daily: "Daily life conversation",
    work: "Dialog between two work colleagues",
    airport: "Looking for a gate at the airport"
};

export const modelToTranslationPT: Record<Model, string> = {
    curiosities: "Curiosities about the country where this language is spoken",
    daily: "Daily life conversation",
    work: "Dialog between two work colleagues",
    airport: "Looking for a gate at the airport"
};

export const motivations: Motivation[] = [
    "travel",
    "work",
    "school",
    "interest",
    "family",
    "other"
];

export const levels: Level[] = ["beginner", "intermediate", "advanced"];
